import React from 'react';
import Hero from '../components/ui/Hero';
import Spreads from '../components/spreads/Spreads';
import Testimonials from '../components/testimonials/Testimonials';

const Landing: React.FC = () => (
  <>
    <Hero
      title='ТАРО'
      subtitle='ТАРО ЧЕТЕНЕ, КОЕТО ТИ ОТГОВАРЯ'
      text='Всеки въпрос има отговор. Виж истината през картите и намери пътя си
            още днес.'
      buttonText='Получи своя отговор'
      onButtonClick={() => window.scrollTo({ top: 768, behavior: 'smooth' })}
    />
    <Spreads />
    <Testimonials />
  </>
);

export default Landing;
